import "prismjs";
import "./prism-javascript";
import "./prism-markup-templating";
import "prismjs/components/prism-ejs";
